import {
  Action,
  ButtonInterface,
  CompanyAdmin,
} from "apps/company/common/dataTypes";

export enum MEMBER_STATUS {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DEACTIVATED = "DEACTIVATED",
  INVITE_EXPIRED = "INVITE EXPIRED",
  INVITE_SENT = "INVITE SENT",
  INVITE_NOT_SENT = "INVITE NOT SENT",
}

export enum MEMBER_ACTION {
  SEND_INVITE = "SEND_INVITE",
  REACTIVATE = "REACTIVATE",
  DEACTIVATE = "DEACTIVATE",
}

export interface Member {
  id: string;
  member: string;
  firstName: string;
  lastName: string;
  email: string;
  timezone: string;
  status: string;
  statusDate: string;
  action: Action;
}

export interface MembersScreen {
  title: string;
  subTitle: string;
  labels: string[];
  searchQuery: string;
  uploadButton: ButtonInterface;
  addButton: ButtonInterface;
  totalPages: number;
  itemsPerPage: number;
  pageNumber: number;
  statusSort: Boolean;
  members: Member[];
}

export interface MemberResultData {
  ok: Boolean;
  companyAdmin: CompanyAdmin;
}
